import React from 'react';
import moment from 'moment';
import 'moment/locale/fr';

import Logo from 'assets/img/Logo_EPS_300.png';

const ROWS_PER_PAGE = 8;

const styles = {
    renderHost: {
        position: 'fixed',
        top: 0,
        left: '-10000px',
        width: '760px',
        pointerEvents: 'none',
        background: '#fff',
    },
    document: {
        width: '760px',
        color: '#111c43',
        background: '#fff',
        fontFamily: 'Arial, Helvetica, sans-serif',
    },
    page: {
        position: 'relative',
        boxSizing: 'border-box',
        width: '760px',
        minHeight: '1110px',
        overflow: 'hidden',
        padding: '48px 46px 38px',
        background: '#fff',
        breakAfter: 'page',
        pageBreakAfter: 'always',
    },
    lastPage: {
        breakAfter: 'auto',
        pageBreakAfter: 'auto',
    },
    ringViolet: {
        position: 'absolute',
        top: '-92px',
        right: '-82px',
        width: '215px',
        height: '215px',
        border: '34px solid rgba(105, 91, 220, 0.13)',
        borderRadius: '50%',
    },
    ringGold: {
        position: 'absolute',
        right: '-70px',
        bottom: '-88px',
        width: '190px',
        height: '190px',
        border: '30px solid rgba(246, 190, 61, 0.17)',
        borderRadius: '50%',
    },
    topbar: {
        position: 'relative',
        zIndex: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: '24px',
        paddingBottom: '22px',
        borderBottom: '1px solid #e5eaf2',
    },
    brand: {
        display: 'flex',
        alignItems: 'center',
        gap: '13px',
    },
    logo: {
        width: '62px',
        height: '62px',
        objectFit: 'contain',
    },
    brandText: {
        display: 'grid',
        gap: '3px',
    },
    brandName: {
        color: '#111c43',
        fontSize: '16px',
        fontWeight: 800,
        letterSpacing: '0.03em',
    },
    brandCaption: {
        color: '#7c89a1',
        fontSize: '10px',
    },
    documentType: {
        height: '28px',
        boxSizing: 'border-box',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        border: '1px solid #d5e1fa',
        borderRadius: '20px',
        padding: '0 13px',
        color: '#2a61d5',
        background: '#f4f7ff',
        fontSize: '10px',
        fontWeight: 700,
    },
    documentTypeText: {
        display: 'block',
        transform: 'translateY(-5px)',
    },
    heading: {
        position: 'relative',
        zIndex: 1,
        marginTop: '30px',
    },
    eyebrow: {
        margin: 0,
        color: '#2a61d5',
        fontSize: '10px',
        fontWeight: 800,
        letterSpacing: '0.12em',
        textTransform: 'uppercase',
    },
    title: {
        margin: '7px 0 7px',
        color: '#111c43',
        fontSize: '29px',
        lineHeight: 1.15,
    },
    description: {
        maxWidth: '580px',
        margin: 0,
        color: '#758199',
        fontSize: '11px',
        lineHeight: 1.55,
    },
    summaryGrid: {
        position: 'relative',
        zIndex: 1,
        display: 'grid',
        gridTemplateColumns: '1.3fr 1fr 1fr',
        gap: '12px',
        marginTop: '24px',
    },
    summaryCard: {
        minHeight: '70px',
        boxSizing: 'border-box',
        display: 'grid',
        alignContent: 'center',
        gap: '7px',
        border: '1px solid #e0e6f0',
        borderRadius: '10px',
        padding: '13px 15px',
        background: '#fbfcff',
    },
    summaryLabel: {
        color: '#7a879f',
        fontSize: '9px',
        fontWeight: 700,
    },
    summaryValue: {
        color: '#111c43',
        fontSize: '13px',
        fontWeight: 800,
        lineHeight: 1.25,
    },
    summaryNumber: {
        color: '#2a61d5',
        fontSize: '21px',
        fontWeight: 850,
    },
    tableSection: {
        position: 'relative',
        zIndex: 1,
        marginTop: '26px',
        border: '1px solid #dce3ee',
        borderRadius: '10px',
        overflow: 'hidden',
        background: '#fff',
    },
    tableTitle: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: '16px',
        padding: '15px 17px',
        borderBottom: '1px solid #e1e7f0',
    },
    tableTitleText: {
        margin: 0,
        color: '#111c43',
        fontSize: '14px',
    },
    tableTitleCaption: {
        color: '#8190aa',
        fontSize: '9px',
    },
    table: {
        width: '100%',
        borderCollapse: 'collapse',
        tableLayout: 'fixed',
    },
    tableHead: {
        color: '#245fd7',
        background: '#f4f7fd',
        fontSize: '9px',
        fontWeight: 800,
        textAlign: 'left',
    },
    th: {
        boxSizing: 'border-box',
        padding: '11px 12px',
        borderBottom: '1px solid #dfe5ee',
    },
    td: {
        boxSizing: 'border-box',
        height: '52px',
        padding: '0 12px',
        borderBottom: '1px solid #e6eaf0',
        color: '#263451',
        fontSize: '10px',
        lineHeight: 1.35,
        verticalAlign: 'middle',
        overflowWrap: 'break-word',
    },
    cellValue: {
        width: '100%',
        minHeight: '52px',
        boxSizing: 'border-box',
        display: 'flex',
        alignItems: 'center',
    },
    cellValueCentered: {
        justifyContent: 'center',
    },
    opticalText: {
        display: 'block',
        width: '100%',
        transform: 'translateY(-6px)',
    },
    cycle: {
        height: '25px',
        boxSizing: 'border-box',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: '15px',
        padding: '0 9px',
        color: '#6542bd',
        background: '#f0ebff',
        fontSize: '9px',
        fontWeight: 800,
        lineHeight: 1,
        textAlign: 'center',
        verticalAlign: 'middle',
        whiteSpace: 'nowrap',
    },
    count: {
        width: '28px',
        height: '28px',
        boxSizing: 'border-box',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: '50%',
        color: '#fff',
        background: '#7550d8',
        fontSize: '10px',
        fontWeight: 800,
        lineHeight: 1,
        textAlign: 'center',
        verticalAlign: 'middle',
    },
    badgeText: {
        display: 'block',
        transform: 'translateY(-6px)',
    },
    footer: {
        position: 'absolute',
        right: '46px',
        bottom: '28px',
        left: '46px',
        zIndex: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        paddingTop: '10px',
        borderTop: '1px solid #e5eaf2',
        color: '#8490a7',
        fontSize: '8px',
    },
};

function chunkRows(rows, size) {
    const chunks = [];
    for (let index = 0; index < rows.length; index += size) {
        chunks.push(rows.slice(index, index + size));
    }
    return chunks.length > 0 ? chunks : [[]];
}

function uppercaseFirstChar(value) {
    if (!value) return '—';
    return value.charAt(0).toUpperCase() + value.slice(1);
}

export default function CreatePdfFilAnnuel({idClasse, classInfo, allSeance, startDate, endDate}) {
    const pages = chunkRows(allSeance, ROWS_PER_PAGE);
    const activityCount = allSeance.reduce((total, row) => total + Number(row.nbSeance || 0), 0);
    const disciplineCount = new Set(allSeance.map((row) => row.nom_sequence)).size;
    const fieldCount = new Set(allSeance.map((row) => row.nom_competence)).size;
    const period = `${moment(startDate).format('DD MMMM YYYY')} — ${moment(endDate).format('DD MMMM YYYY')}`;

    return (
        <div style={styles.renderHost} aria-hidden="true">
            <div id="fil_annuel" style={styles.document}>
                {pages.map((rows, pageIndex) => (
                    <section
                        key={`annual-pdf-page-${pageIndex}`}
                        style={{
                            ...styles.page,
                            ...(pageIndex === pages.length - 1 ? styles.lastPage : {}),
                        }}
                    >
                        <div style={styles.ringViolet} />
                        <div style={styles.ringGold} />

                        <header style={styles.topbar}>
                            <div style={styles.brand}>
                                <img src={Logo} alt="" style={styles.logo} />
                                <span style={styles.brandText}>
                                    <strong style={styles.brandName}>ACCÈS EPS</strong>
                                    <small style={styles.brandCaption}>Synthèse pédagogique</small>
                                </span>
                            </div>
                            <span style={styles.documentType}><span style={styles.documentTypeText}>FIL ANNUEL</span></span>
                        </header>

                        <div style={styles.heading}>
                            <p style={styles.eyebrow}>Bilan de la période</p>
                            <h1 style={styles.title}>Fil annuel EPS</h1>
                            <p style={styles.description}>
                                Synthèse des disciplines pour lesquelles au moins une activité a été évaluée avec la classe.
                            </p>
                        </div>

                        <div style={styles.summaryGrid}>
                            <div style={styles.summaryCard}>
                                <small style={styles.summaryLabel}>Classe et niveau(x)</small>
                                <strong style={styles.summaryValue}>
                                    {classInfo?.nom_classe || `Classe ${idClasse}`} · {classInfo?.niveau || '—'}
                                </strong>
                                <small style={styles.summaryLabel}>{period}</small>
                            </div>
                            <div style={styles.summaryCard}>
                                <small style={styles.summaryLabel}>Disciplines abordées</small>
                                <strong style={styles.summaryNumber}>{disciplineCount}</strong>
                            </div>
                            <div style={styles.summaryCard}>
                                <small style={styles.summaryLabel}>Activités évaluées</small>
                                <strong style={styles.summaryNumber}>{activityCount}</strong>
                            </div>
                        </div>

                        <div style={styles.tableSection}>
                            <div style={styles.tableTitle}>
                                <h2 style={styles.tableTitleText}>Synthèse des apprentissages</h2>
                                <span style={styles.tableTitleCaption}>{fieldCount} champ{fieldCount > 1 ? 's' : ''} d'apprentissage</span>
                            </div>
                            <table style={styles.table}>
                                <colgroup>
                                    <col style={{width: '13%'}} />
                                    <col style={{width: '37%'}} />
                                    <col style={{width: '35%'}} />
                                    <col style={{width: '15%'}} />
                                </colgroup>
                                <thead style={styles.tableHead}>
                                    <tr>
                                        <th style={styles.th}>Cycle</th>
                                        <th style={styles.th}>Champ d'apprentissage</th>
                                        <th style={styles.th}>Discipline</th>
                                        <th style={{...styles.th, textAlign: 'center'}}>Activités</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {rows.map((row, rowIndex) => (
                                        <tr key={`${row.id_cycle}-${row.nom_sequence}-${rowIndex}`} style={{background: rowIndex % 2 === 0 ? '#fff' : '#fbfcff'}}>
                                            <td style={styles.td}>
                                                <div style={styles.cellValue}>
                                                    <span style={styles.cycle}><span style={styles.badgeText}>Cycle {row.id_cycle}</span></span>
                                                </div>
                                            </td>
                                            <td style={styles.td}>
                                                <div style={styles.cellValue}><span style={styles.opticalText}>{uppercaseFirstChar(row.nom_competence)}</span></div>
                                            </td>
                                            <td style={{...styles.td, fontWeight: 700}}>
                                                <div style={styles.cellValue}><span style={styles.opticalText}>{row.nom_sequence || '—'}</span></div>
                                            </td>
                                            <td style={{...styles.td, textAlign: 'center'}}>
                                                <div style={{...styles.cellValue, ...styles.cellValueCentered}}>
                                                    <span style={styles.count}><span style={styles.badgeText}>{row.nbSeance || 0}</span></span>
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>

                        <footer style={styles.footer}>
                            <span>© 2024 Accès EPS — Document généré depuis l'espace enseignant</span>
                            <span>Page {pageIndex + 1} / {pages.length}</span>
                        </footer>
                    </section>
                ))}
            </div>
        </div>
    );
}
